import {
	DEFAULT_HOME_DOCUMENT_TYPE,
	setHomeDocumentType,
} from '@UI/Pages/Home/Signals/homeDocumentTypeSignal';
import homeDocumentTypeSignal from '@UI/Pages/Home/Signals/homeDocumentTypeSignal';
import homePeriodSignal, { setHomePeriod } from '@UI/Pages/Home/Signals/homePeriodSignal';
import { DEFAULT_HOME_SCOPE, setHomeScope } from '@UI/Pages/Home/Signals/homeScopeSignal';
import useHomeIndicatorScope from '@UI/Pages/Home/Hooks/useHomeIndicatorScope';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';

export type WidenIndicatorAction = {
	readonly label: string;
	readonly run: () => void;
};

/**
 * The one step that widens an empty indicator, in order: drop the type filter, extend the period to
 * 90 days, then take the whole perimeter. `null` once nothing is left to widen.
 */
const useWidenIndicatorAction = (includeDocumentType: boolean): WidenIndicatorAction | null => {
	const period = useSignalValue(homePeriodSignal);
	const documentTypeId = useSignalValue(homeDocumentTypeSignal);
	const { scope } = useHomeIndicatorScope();

	return React.useMemo(() => {
		if (includeDocumentType && documentTypeId !== null) {
			return {
				label: 'Voir tous les types',
				run: () => setHomeDocumentType(DEFAULT_HOME_DOCUMENT_TYPE),
			};
		}

		if (period < 90) {
			return { label: 'Voir sur 90 jours', run: () => setHomePeriod(90) };
		}

		if (scope.kind !== 'all') {
			return { label: 'Tout mon périmètre', run: () => setHomeScope(DEFAULT_HOME_SCOPE) };
		}

		return null;
	}, [includeDocumentType, documentTypeId, period, scope.kind]);
};

export default useWidenIndicatorAction;
